/* eslint-disable @typescript-eslint/no-namespace */
/* eslint-disable max-classes-per-file */
import { IsOptional, ValidateNested } from 'class-validator';
import { ClassConstructor, Type } from 'class-transformer';
import { httpClient, IsOptionalString } from '../../../http-client';
import { AxiosRequestConfig } from 'axios';

export namespace authForgotDTO {
  export interface Req {
    email: string;
  }

  export class Res {
    @IsOptionalString()
    data?: string;
  }

  export class Response {
    @IsOptional()
    @ValidateNested()
    @Type(() => Res)
    res?: Res | null;
  }
}

export const authForgot = (
  reqData: authForgotDTO.Req,
  config = {} as AxiosRequestConfig & {
    dto: ClassConstructor<authForgotDTO.Res>;
  }
) => {
  config.dto = authForgotDTO.Res;
  return httpClient.post<authForgotDTO.Res>('/user/password', reqData, config);
};
